<div class="row" >
    <div class="col-md-12">
        <div class="row modal_header">
            <div class="col-9">
                <span class="ml-2">Product Details </span>
            </div>
            <div class="col-3 text-right">
                <a style="cursor: pointer">
                    <i
                        class="fa-solid fa-xmark"
                        (click)="Close()"
                        style="font-size: xx-large"
                    ></i>
                </a>
            </div>
        </div>
    <div class="card card_content">
<div class="table-responsive mt-2 mb-4">
    <mat-table #table [dataSource]="dataSource" >

      <ng-container matColumnDef="ServiceProviderName">
        <mat-header-cell *matHeaderCellDef >Service Provider Name</mat-header-cell>
        <mat-cell *matCellDef="let dataField">
          <p class="text-truncate txtalign"> {{dataField.serviceProvider}}</p>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="ProductId">
        <mat-header-cell *matHeaderCellDef >Product Id</mat-header-cell>
        <mat-cell *matCellDef="let dataField">
          <p class="text-truncate txtalign">{{dataField.productId}}</p>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="ProductName">
        <mat-header-cell *matHeaderCellDef > Product Name</mat-header-cell>
        <mat-cell *matCellDef="let dataField">
          <p class="text-truncate txtalign">{{dataField.aliasName}} </p>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="Cost" >
        <mat-header-cell *matHeaderCellDef [hidden]="sessionDataString.roletype == roletype.Technician">Cost</mat-header-cell>
        <mat-cell *matCellDef="let dataField" [hidden]="sessionDataString.roletype == roletype.Technician">
          <p class="text-truncate txtalign">R {{dataField.totalProductCost.toFixed(2)}}</p>
        </mat-cell>
      </ng-container>
    

      <mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>

      <mat-row *matRowDef="let row; columns: displayedColumns;" matRipple>
      </mat-row>

    </mat-table>
  </div>
  </div>
  </div>

